import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const timeSeriesMetric = z.array(
  z.object({ plainDate: z.string(), value: z.number().optional() }),
);

export const getWidgetsTimeSeriesMetrics = {
  name: "getWidgetsTimeSeriesMetrics" as const,
  input: z
    .object({
      dateRange: z
        .object({ start: zExt.plainDate(), end: zExt.plainDate() })
        .optional(),
      widgetId: zExt.objectId().optional(),
    })
    .nullable(),
  output: z.object({
    incrementalRevenueOverTimeSeries: timeSeriesMetric,
    currency: createEnum(Currency),
  }),
};
